import React, { useState, useEffect } from 'react';
import router from 'umi/router';

import lgText from '../../config/language';
import { btnBackgroundColor } from '@/utils/theme';
import { getValue } from '../../utils/getValue';
const styles = require('./index.less');

interface IProps {
  type?: 'cip';
}
const EXPIRE = 2;

// true 没过期  false 过期
const getIsExpire = (expireKey, expireNum) => {
  // 存起来的时间
  const timer = localStorage.getItem(expireKey) || 0;
  const expire = new Date(Number(timer)); // 过期时间
  const nowTimer = new Date().getTime(); //现在时间
  const expireTimer = new Date(expire.setHours(expire.getHours() + 1)).getTime();
  return expireTimer > nowTimer;
};

// 网点判断是否可以展示去使用url
const getUse = () => {
  let useBut: any = localStorage.getItem('useBut');
  let useUrl: any = localStorage.getItem('useUrl');
  useBut = useBut ? JSON.parse(useBut) : {};
  useUrl = useUrl ? JSON.parse(useUrl) : {};
  let canShowBtn = useBut.value === 'true';
  let url = useUrl.value || '';
  try {
    const btnExpire = new Date(useBut.expire);
    const urlExpire = new Date(useUrl.expire);
    const newDate = new Date().getTime();
    const btnExpireTimer = new Date(btnExpire.setHours(btnExpire.getHours() + EXPIRE)).getTime();
    const urlExpireTimer = new Date(urlExpire.setHours(urlExpire.getHours() + EXPIRE)).getTime();
    canShowBtn = btnExpireTimer > newDate && canShowBtn;
    const isUrlExpire = urlExpireTimer > newDate; // true 没过期 false过期
    url = isUrlExpire ? url : '';
  } catch (error) {
    canShowBtn = false;
    url = '';
  }

  return {
    showBtn: canShowBtn,
    url,
  };
};

export default function LoginPage(props: IProps) {
  const lg = getValue('language') || 'zh-cn';
  const channel = getValue('channel');
  const dragoncode = getValue('dragoncode');
  const [showBtn, setShowBtn] = useState(false);
  const [useUrl, setUseUrl] = useState('');
  const { type } = props;
  const isCip = type === 'cip';
  useEffect(() => {
    const { showBtn, url } = getUse();
    if (isCip) {
      const cipShowBtn = getIsExpire('tokenTimer', 1);
      setShowBtn(cipShowBtn);
      return;
    }
    setShowBtn(showBtn);
    setUseUrl(url);
  }, []);
  const toUse = () => {
    let pathname = '/use';
    if (useUrl) {
      if (useUrl.indexOf('http') !== -1) {
        window.location.href = useUrl;
        return;
      }
      pathname = useUrl;
    }
    if (isCip) {
      pathname = '/cip';
    }
    router.push({
      pathname,
      query: {
        dragoncode,
        channel,
        language: lg,
      },
    });
  };
  const background =
    btnBackgroundColor[channel] ||
    'linear-gradient(90deg, rgba(255, 48, 48, 1) 0%, rgba(255, 121, 71, 1) 100%)';
  return (
    <div className={styles.footerWrapper} style={{ display: showBtn ? 'block' : 'none' }}>
      <div className={styles.btn} style={{ background }} onClick={toUse}>
        {lgText['Usebtn']}
      </div>
    </div>
  );
}
